module.exports = __webpack_public_path__ + "img/stock7.6f102ae7.png";